
<section class="page-section" id='contact'>
  <div >
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Contact Us</h2>
            <h3 class="section-subheading">We would love to here from you.</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="contact-details row">
              <div class="col-sm-6 col-md-4  text-center">
                <i class="fa fa-envelope-open text-fsp font-weight-light"></i>
                <p>
                  admin@fspersonnel.co.za<br/>info@fspersonnel.co.za
                </p>
              </div>
              <div class="col-sm-6 col-md-4 text-center">
                <i class="fa fa-phone text-fsp font-weight-light"></i>
                <p>
                  062 021 3567
                </p>
              </div>
              <div class="col-sm-6 col-md-4 text-center">
                <i class="fa fa-skype text-fsp font-weight-light"></i>
                <p>
                  fspersonnel admin
                </p>
              </div>
              <div class="col-sm-6 col-md-4 text-center">
                <i class="fa fa-facebook text-fsp font-weight-light"></i>
                <p>
                  FS Personnel
                </p>
              </div>
              <div class="col-sm-6 col-md-4 text-center">
                <i class="fa fa-twitter text-fsp font-weight-light"></i>
                <p>
                  FS Personnel
                </p>
              </div>
              <div class="col-sm-6 col-md-4 text-center">
                <i class="fa fa-linkedin text-fsp font-weight-light"></i>
                <p>
                  FS Personnel 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>
<section class="page-section contact-form">
  <div class="extra-background">
      <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Message</h2>
              <h3 class="section-subheading">Complete the form below to send us message.</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <form id="contactForm" name="sentMessage" novalidate="novalidate">
                <div class="row">
                  <div class="col-md-6">
                    
                    <mat-form-field appearance="outline">
                      <mat-label>Subject</mat-label>
                      <mat-select>
                        <mat-option value="General Feedback">General Feedback</mat-option>
                        <mat-option value="Contact Request">Contact Request</mat-option>
                        <mat-option value="Price Quote">Price Quote</mat-option>
                        <mat-option value="Information Request">Information Request</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Name</mat-label>
                      <input matInput placeholder="Your Name *"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput placeholder="Your Email *"/>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Home Phone</mat-label>
                      <input matInput type="tel" placeholder="Your Home Phone *"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Work Phone</mat-label>
                      <input matInput type="tel" placeholder="Your Work Phone *"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Cell Phone</mat-label>
                      <input matInput type="tel" placeholder="Your Cell Phone *"/>
                    </mat-form-field>
                  </div>
                  <div class="col-md-12">
                    <mat-form-field appearance="outline">
                      <mat-label>Message</mat-label>
                      <textarea matInput placeholder="Your Message *"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 form-question" >
                    <div class="form-group">
                      <p class="help-block ">When is the best time to contact you?</p>
                      <mat-button-toggle-group>
                          <mat-button-toggle>Morning</mat-button-toggle>
                          <mat-button-toggle>Afternoon</mat-button-toggle>
                          <mat-button-toggle>Evening</mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                  </div>
                  <div class="col-md-6 form-question">
                    <div class="form-group">
                      <p class="help-block">When is the best way to contact you?</p>
                      <mat-button-toggle-group color="primary">
                        <mat-button-toggle >Phone</mat-button-toggle>
                        <mat-button-toggle>Email</mat-button-toggle>
                    </mat-button-toggle-group>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="col-lg-12 text-center">
                    <div id="success"></div>
                    <button id="sendMessageButton" class="btn btn-fsp btn-xl text-uppercase" type="submit">Send Message</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
  </section>
